export default __webpack_public_path__ + "static/media/dollarSign.c2a9e2ac.svg";